export const calculationsTypes = {
  prev: "Prev",
  rent: "JusCalc Aluguel",
  childcare: "JusCalc Pensão",
  correction_simple_fgts: "JusCalc Correção do FGTS",
  labor: "JusTrabalhista",
  pasep: "JusCalc Revisão do PASEP",
  rmc: "JusCalc RMC e RCC INSS",
  overdebt: "JusCalc Superendividamento",
  review: "JusRevisional",
  correction_complete: "Juscalc Completo",
  correction_simple: "JusCalc Fácil",
  sentence: "JusCriminal Dosimetria da pena",
  regime_progression: "JusCriminal Progressão de regime",
  inss: "JusCalc INSS (Restituição)",
  divorce_calc: "JusCalc Divórcio"
};
